import { Outlet } from 'react-router-dom'
import DashHeader from './DashHeader'
import DashFooter from './DashFooter'

const DashLayout = () => {
    return (
        <>
            <div className='flex flex-col h-screen text-white'>
                <div className='border-b-2 bg-[#151a26] border-gray-600'>
                    <DashHeader />
                </div>
               
               <div className='mt-[3rem]'>
                     <Outlet />
                     </div>
                <DashFooter />
            </div>
        </>
    )
}
export default DashLayout